import React, { useEffect, useState } from 'react';
import { JSON_ONE } from "./JSON_DATA_Request";
import { JSON_ONE1 } from "./JSON_DATA_Response";
import { JSON_ONE11} from "./JSON_DATA_Requestflowone";
import { JSON_ONE21 } from "./JSON_DATA_Responseflowone";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import ResponseJSON from './ResponseJSON';
import RequestJSON from './RequestJSON';
import RequestJSONflowone from './RequestJSONflowone';
import ResponseJSONflowone from './ResponseJSONflowone';
function ResellerAPI() {
const [ShowHideAccordionOne, SetShowHideAccordionOne] = useState(false);
const [ShowHideAccordionTwo, SetShowHideAccordionTwo] = useState(false);
const onClickAccordianShowHideOne = () => {
SetShowHideAccordionOne(!ShowHideAccordionOne)
}
const onClickAccordianShowHideTwo = () => {
SetShowHideAccordionTwo(!ShowHideAccordionTwo)
}
const [TabCheck1, SetTabCheck1] = useState(false)
const [TabCheck2, SetTabCheck2] = useState(false)
const onClickCangeTab1 = () => {
SetTabCheck1(!TabCheck1);
}
const onClickCangeTab2 = () => {
SetTabCheck2(!TabCheck2);
}
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_layout1">
               <h1>Reseller API</h1>
               <hr/>
            </section>
         </div>
         <div class="col-md-4 extreme-rt-div">
         </div>
      </div>
      <div class="row">
         <div class="col-md-8 mt-60">
            <h2 id="get-merchant-list-api-sec">GET Merchant List API</h2>
            <p>
               An API which will give the list of merchants under that reseller account.
            </p>
            <u>
               <p>
                  AUTHORIZATIONS:
               </p>
            </u>
            <p className='mb-0'>REQUEST BODY SCHEMA: application/json</p>
            <hr className='hr-col'>
            </hr>
            <table class="sc-hHEiqL iZJLLY">
               <tr className='expanded'>
                  <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideOne}>
                     <span className='sc-iemWCZ fhDkLh'></span>
                     <span>
                        encryptText {ShowHideAccordionOne ? 
                        <FaAngleDown/>
                        : 
                        <FaAngleUp/>
                        }
                     </span>
                  </td>
                  <td class="sc-bkbkJK gmOLLi">
                     <div>
                        <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                           <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                        </div>
                        <div>
                           <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                        </div>
                     </div>
                  </td>
               </tr>
               {ShowHideAccordionOne &&
               <tr>
                  <td colspan="2" className="sc-hBMUJo sc-fnVZcZ hmqpxx">
                     <div className="sc-dIvrsQ kPKTxr">
                        <table class="sc-hHEiqL iZJLLY">
                           <tbody>
                              <tr>
                                 <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="aggregator_id"><span class="sc-iemWCZ fhDkLh"></span><span>aggregator_id</span></td>
                                 <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                       <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                       <div>
                                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                             <p>Aggregator ID.</p>
                                          </div>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                              <tr>
                                 <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="merchant_id"><span class="sc-iemWCZ fhDkLh"></span><span>merchant_id</span></td>
                                 <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                       <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                       <div>
                                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                             <p>Merchant ID issued to you by safexpay</p>
                                          </div>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                              <tr>
                                 <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="from_date"><span class="sc-iemWCZ fhDkLh"></span><span>from_date</span></td>
                                 <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                       <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                       <div>
                                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                             <p>Transactions beginning from date format</p>
                                          </div>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                              <tr>
                                 <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="to_date"><span class="sc-iemWCZ fhDkLh"></span><span>to_date</span></td>
                                 <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                       <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                       <div>
                                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                             <p>Transactions till date</p>
                                          </div>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                              <tr>
                                 <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymode"><span class="sc-iemWCZ fhDkLh"></span><span>paymode</span></td>
                                 <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                       <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                       <div>
                                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                             <p>Pay mode- Credit card:CC, Debit card:DC, Netbanking:NB, upi:UP, wallets:WA,All</p>
                                          </div>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                              <tr>
                                 <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                                 <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                       <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                       <div>
                                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                             <p>Status like success, fail, pending, refund, all</p>
                                          </div>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                              <tr>
                                 <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="reseller_id"><span class="sc-iemWCZ fhDkLh"></span><span>reseller_id</span></td>
                                 <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                       <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                       <div>
                                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                             <p>Transactions beginning from amount</p>
                                          </div>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                              <tr>
                                 <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_id"><span class="sc-iemWCZ fhDkLh"></span><span>pg_id</span></td>
                                 <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                       <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                       <div>
                                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                             <p>Transactions till amount</p>
                                          </div>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                              <tr>
                                 <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="limit_from"><span class="sc-iemWCZ fhDkLh"></span><span>limit_from</span></td>
                                 <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                       <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                       <div>
                                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                             <p>No. of transactions can be used for pagination</p>
                                          </div>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                              <tr>
                                 <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="limit_to"><span class="sc-iemWCZ fhDkLh"></span><span>limit_to</span></td>
                                 <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                       <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                       <div>
                                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                             <p>No. of transactions can be used for pagination.</p>
                                          </div>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                              <tr>
                                 <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="order_numbers"><span class="sc-iemWCZ fhDkLh"></span><span>order_numbers</span></td>
                                 <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                       <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                       <div>
                                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                             <p>Order number will be unique value which is generated by merchant</p>
                                          </div>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                              <tr>
                                 <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_references"><span class="sc-iemWCZ fhDkLh"></span><span>ag_references</span></td>
                                 <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                       <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                       <div>
                                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                             <p>Agrefernce number will be unique value which is generated by Aggregator</p>
                                          </div>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                              <tr class="last undefined">
                                 <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="request_type"><span class="sc-iemWCZ fhDkLh"></span><span>request_type</span></td>
                                 <td class="sc-bkbkJK gmOLLi">
                                    <div>
                                       <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                       <div>
                                          <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                             <p>gerMislist</p>
                                          </div>
                                       </div>
                                    </div>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </td>
               </tr>
               }
            </table>
            <h5 className="mt-30">Responses</h5>
            <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
               <div class="card">
                  <div class="card-header" id="heading1">
                     <h5 class="mb-0">
                        <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                        <b>200</b> A refund reponse json object {TabCheck1 ?
                        <FaAngleUp />
                        :
                        <FaAngleDown />
                        }
                  </div>
                  </h5>
               </div>
               {
               TabCheck1 &&
               <div>
                  <div class="card-body">
                     <h6 class="mt-10"><span>RESPONSE SCHEMA: </span> <span style={{ color: "#313131" }}>application/json</span></h6>
                     <hr class="hr-col">
                     </hr>
                     <div>
                        <div class="sc-bCwfaz ilMEYI"> Array ()          [</div>
                        <div class="sc-jQAxuV NAoOF">
                           <table class="sc-hHEiqL iZJLLY">
                              <tbody>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>merchant ID fetched.</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr class="last undefined">
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="merchant_name"><span class="sc-iemWCZ fhDkLh"></span><span>merchant_name</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Merchant name fetched.</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                        <div class="sc-iwajpm bcEyfL">]</div>
                     </div>
                  </div>
               </div>
               }
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>400 Bad request</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>404 Not found</span> </h5>
               </div>
            </div>
         </div>
      </div>
      <div class="col-md-4 extreme-rt-div">
         <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
            <div class="card">
               <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                     <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab1}>
                     <button> POST </button> /resellerMerchantList/agId/ paygate {TabCheck1 ?
                     <FaAngleUp />
                     :
                     <FaAngleDown />
                     }
               </div>
               </h5>
            </div>
            {
            TabCheck1 &&
            <div>
               <br />
               <div class="card-body">
                  <p class="mb-0">Production server (uses live data)</p>
                  <div class="api-div-bor">
                     <span>https://www.avantgardepayments.com</span>
                     <span class="col-org">/agadmin/resellerMerchantList/agId/paygate</span>
                  </div>
                  <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                  <div class="api-div-bor">
                     <span>https://pguat.safexpay.com</span><span
                        class="col-org">/agadmin/resellerMerchantList/agId/paygate</span>
                  </div>
               </div>
            </div>
            }
         </div>
      </div>
      <RequestJSON/>
      <ResponseJSON/>
   </div>
</div>
<hr class="hr-seperator"></hr>
<div class="row">
   <div class="col-md-8 mt-60">
      <h2 id="get-transaction-mis-api-sec">GET Transaction MIS API</h2>
      <p>
         An API that will give the list of transactions done by the reseller’s merchant. This API helps Reseller to see the transaction status of their merchant with their Payout and settlement status. For checking the Payout and settlement status, need to consider the ‘sub status and ‘sub status description’ parameters. Sub Status List is as follows.<br></br>
         Sub Status List are as follows
      </p>
      <table>
         <tr>
            <th>SUB_STATUS</th>
            <th width="5%"></th>
            <th>DESCRIPTION</th>
         </tr>
         <tr className='hr-col'>
            <td>03</td>
            <td></td>
            <td>Sale Request Received</td>
         </tr>
         <tr className='hr-col'>
            <td>04</td>
            <td></td>
            <td>Refund request Initiated</td>
         </tr>
         <tr className='hr-col'>
            <td>05</td>
            <td></td>
            <td>Request Sent to Payment Gateway / Bank</td>
         </tr>
         <tr className='hr-col'>
            <td>06</td>
            <td></td>
            <td>Response Received from Payment Gateway / Bank</td>
         </tr>
         <tr className='hr-col'>
            <td>09</td>
            <td></td>
            <td>No Response Received from Payment Gateway / Bank</td>
         </tr>
         <tr className='hr-col'>
            <td>16</td>
            <td></td>
            <td>Sale Request Processed</td>
         </tr>
         <tr className='hr-col'>
            <td>17</td>
            <td></td>
            <td>ale Request Failed</td>
         </tr>
         <tr className='hr-col'>
            <td>18</td>
            <td></td>
            <td>Refund Request Processed</td>
         </tr>
         <tr className='hr-col'>
            <td>19</td>
            <td></td>
            <td>Refund Request Failed</td>
         </tr>
         <tr className='hr-col'>
            <td>20</td>
            <td></td>
            <td>Reconciled with Payment Gateway / Bank</td>
         </tr>
         <tr className='hr-col'>
            <td>21</td>
            <td></td>
            <td>Settlement Done</td>
         </tr>
         <tr className='hr-col'>
            <td>23</td>
            <td></td>
            <td>Merchant Payout Done</td>
         </tr>
         <tr className='hr-col'>
            <td>24</td>
            <td></td>
            <td>Cancelled by Customer</td>
         </tr>
         <tr className='hr-col'>
            <td>25</td>
            <td></td>
            <td>Aborted</td>
         </tr>
      </table>
      <u>
         <p className="mt-30">
            AUTHORIZATIONS:
         </p>
      </u>
      <p className='mb-0'>REQUEST BODY SCHEMA: application/json</p>
      <hr className='hr-col'>
      </hr>
      <table class="sc-hHEiqL iZJLLY">
         <tbody>
            <tr className='expanded last undefined'>
               <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideTwo}>
                  <span className='sc-iemWCZ fhDkLh'></span>
                  <span>
                     encryptText {ShowHideAccordionTwo ? 
                     <FaAngleDown/>
                     : 
                     <FaAngleUp/>
                     }
                  </span>
               </td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                        <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                     </div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                     </div>
                  </div>
               </td>
            </tr>
            {ShowHideAccordionTwo &&
            <tr className='expanded last undefined'>
               <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                  <div className="sc-dIvrsQ kPKTxr">
                     <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="aggregator_id"><span class="sc-iemWCZ fhDkLh"></span><span>aggregator_id</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Aggregator ID.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="merchant_id"><span class="sc-iemWCZ fhDkLh"></span><span>merchant_id</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Merchant ID issued to you by safexpay</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="from_date"><span class="sc-iemWCZ fhDkLh"></span><span>from_date</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Transactions beginning from date format</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="to_date"><span class="sc-iemWCZ fhDkLh"></span><span>to_date</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Transactions till date</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymode"><span class="sc-iemWCZ fhDkLh"></span><span>paymode</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Pay mode- Credit card:CC, Debit card:DC, Netbanking:NB, upi:UP, wallets:WA,All</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Status like success, fail, pending, refund, all</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="reseller_id"><span class="sc-iemWCZ fhDkLh"></span><span>reseller_id</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Transactions beginning from amount</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_id"><span class="sc-iemWCZ fhDkLh"></span><span>pg_id</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Transactions till amount</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="limit_from"><span class="sc-iemWCZ fhDkLh"></span><span>limit_from</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>No. of transactions can be used for pagination</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="limit_to"><span class="sc-iemWCZ fhDkLh"></span><span>limit_to</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>No. of transactions can be used for pagination.</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="order_numbers"><span class="sc-iemWCZ fhDkLh"></span><span>order_numbers</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Order number will be unique value which is generated by merchant</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_references"><span class="sc-iemWCZ fhDkLh"></span><span>ag_references</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Agrefernce number will be unique value which is generated by Aggregator</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr class="last undefined">
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="request_type"><span class="sc-iemWCZ fhDkLh"></span><span>request_type</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>gerMislist</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </td>
            </tr>
            }
            <tr class="last undefined">
               <td class="sc-hBMUJo sc-fFSPTT dMYtew feWFnv" kind="additionalProperties" title="property name*"><span class="sc-iemWCZ fhDkLh"></span><span><i>property name*</i></span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                     </div>
                  </div>
               </td>
            </tr>
         </tbody>
      </table>
      <h5 className="mt-30">Responses</h5>
      <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
         <div class="card">
            <div class="card-header" id="heading1">
               <h5 class="mb-0">
                  <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                  <b>200</b> A refund reponse json object {TabCheck1 ?
                  <FaAngleUp />
                  :
                  <FaAngleDown />
                  }
            </div>
            </h5>
         </div>
         {
         TabCheck1 &&
         <div>
            <div class="card-body">
               <h6 class="mt-10"><span>RESPONSE SCHEMA: </span> <span style={{ color: "#313131" }}>application/json</span></h6>
               <hr class="hr-col">
               </hr>
               <table class="sc-hHEiqL iZJLLY">
                  <tbody>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="transaction_id"><span class="sc-iemWCZ fhDkLh"></span><span>transaction_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>transaction id fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Merchant id fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>aggregrator ID fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="order_no"><span class="sc-iemWCZ fhDkLh"></span><span>order_no</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>order no fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_id"><span class="sc-iemWCZ fhDkLh"></span><span>pg_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>paygate ID fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymode_id"><span class="sc-iemWCZ fhDkLh"></span><span>paymode_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>paymode id fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="requested_paymode_id"><span class="sc-iemWCZ fhDkLh"></span><span>requested_paymode_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>requested paymode ID fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="scheme_id"><span class="sc-iemWCZ fhDkLh"></span><span>scheme_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>scheme id fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="emi_months"><span class="sc-iemWCZ fhDkLh"></span><span>emi_months</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>emi months fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="unique_id"><span class="sc-iemWCZ fhDkLh"></span><span>unique_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>unique id fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="address_count"><span class="sc-iemWCZ fhDkLh"></span><span>address_count</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>address count fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="item_value"><span class="sc-iemWCZ fhDkLh"></span><span>item_value</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>item value fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="transaction_statusid"><span class="sc-iemWCZ fhDkLh"></span><span>transaction_statusid</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>transaction statusid fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="sub_status"><span class="sc-iemWCZ fhDkLh"></span><span>sub_status</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>sub_status fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="sub_status_description"><span class="sc-iemWCZ fhDkLh"></span><span>sub_status_description</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>sub status description fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_ref"><span class="sc-iemWCZ fhDkLh"></span><span>ag_ref</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>aggregator ref fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="merchant_name"><span class="sc-iemWCZ fhDkLh"></span><span>merchant_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>merchant name fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="merchant_address"><span class="sc-iemWCZ fhDkLh"></span><span>merchant_address</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Merchant address fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="merchant_country"><span class="sc-iemWCZ fhDkLh"></span><span>merchant_country</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>merchant country fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="aggregator_name"><span class="sc-iemWCZ fhDkLh"></span><span>aggregator_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>aggregator_name fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="country_code"><span class="sc-iemWCZ fhDkLh"></span><span>country_code</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>country code fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="currency_code"><span class="sc-iemWCZ fhDkLh"></span><span>currency_code</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>currency code fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_name"><span class="sc-iemWCZ fhDkLh"></span><span>pg_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>paygate name fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="transaction_date"><span class="sc-iemWCZ fhDkLh"></span><span>transaction_date</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>transaction date fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymode_name"><span class="sc-iemWCZ fhDkLh"></span><span>paymode_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>paymode name fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_type"><span class="sc-iemWCZ fhDkLh"></span><span>txn_type</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>transaction type fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="success_url"><span class="sc-iemWCZ fhDkLh"></span><span>success_url</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>success url fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="failure_url"><span class="sc-iemWCZ fhDkLh"></span><span>failure_url</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>failure url fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="channel"><span class="sc-iemWCZ fhDkLh"></span><span>channel</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>channel fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ip_address"><span class="sc-iemWCZ fhDkLh"></span><span>ip_address</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>ip address fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="server_name"><span class="sc-iemWCZ fhDkLh"></span><span>server_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>server name fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_name"><span class="sc-iemWCZ fhDkLh"></span><span>cust_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>cust name fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="email_id"><span class="sc-iemWCZ fhDkLh"></span><span>email_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>email id fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="mobile_no"><span class="sc-iemWCZ fhDkLh"></span><span>mobile_no</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>mobile no fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="is_logged_in"><span class="sc-iemWCZ fhDkLh"></span><span>is_logged_in</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>logged_in details fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bill_address"><span class="sc-iemWCZ fhDkLh"></span><span>bill_address</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>bill address fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bill_city"><span class="sc-iemWCZ fhDkLh"></span><span>bill_city</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>bill city fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bill_state"><span class="sc-iemWCZ fhDkLh"></span><span>bill_state</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>bill state fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bill_country"><span class="sc-iemWCZ fhDkLh"></span><span>bill_country</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>bill state fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bill_zip"><span class="sc-iemWCZ fhDkLh"></span><span>bill_zip</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>bill zip fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ship_address"><span class="sc-iemWCZ fhDkLh"></span><span>ship_address</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>ship address fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ship_city"><span class="sc-iemWCZ fhDkLh"></span><span>ship_city</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>ship city fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ship_state"><span class="sc-iemWCZ fhDkLh"></span><span>ship_state</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>ship state fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ship_zip"><span class="sc-iemWCZ fhDkLh"></span><span>ship_zip</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>ship zip fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="item_category"><span class="sc-iemWCZ fhDkLh"></span><span>item_category</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>item category fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="transaction_requestdate"><span class="sc-iemWCZ fhDkLh"></span><span>transaction_requestdate</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>transaction requestdate fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_ref"><span class="sc-iemWCZ fhDkLh"></span><span>pg_ref</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>paygate ref fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>status fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="remarks"><span class="sc-iemWCZ fhDkLh"></span><span>remarks</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>remarks fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="transaction_statusdate"><span class="sc-iemWCZ fhDkLh"></span><span>transaction_statusdate</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>transaction statusdate fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fee"><span class="sc-iemWCZ fhDkLh"></span><span>fee</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>fee fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meIgst"><span class="sc-iemWCZ fhDkLh"></span><span>meIgst</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Merchant Igst fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meCgst"><span class="sc-iemWCZ fhDkLh"></span><span>meCgst</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>merchant Cgst fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meSgst"><span class="sc-iemWCZ fhDkLh"></span><span>meSgst</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Merchant Sgst fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agIgst"><span class="sc-iemWCZ fhDkLh"></span><span>agIgst</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>aggregator Igst fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agCgst"><span class="sc-iemWCZ fhDkLh"></span><span>agCgst</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>aggregator Cgst fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agSgst"><span class="sc-iemWCZ fhDkLh"></span><span>agSgst</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>aggregator Sgst fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgIgst"><span class="sc-iemWCZ fhDkLh"></span><span>pgIgst</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>paygate Igst fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgCgst"><span class="sc-iemWCZ fhDkLh"></span><span>pgCgst</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>paygate Cgst fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgSgst"><span class="sc-iemWCZ fhDkLh"></span><span>pgSgst</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>paygate Sgst fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="reIgst"><span class="sc-iemWCZ fhDkLh"></span><span>reIgst</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>reseller Igst fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="reCgst"><span class="sc-iemWCZ fhDkLh"></span><span>reCgst</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>reseller Cgst fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="reSgst"><span class="sc-iemWCZ fhDkLh"></span><span>reSgst</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>reseller Sgst fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_fee"><span class="sc-iemWCZ fhDkLh"></span><span>ag_fee</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>aggregator fee fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="amount"><span class="sc-iemWCZ fhDkLh"></span><span>amount</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>amount fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="discount"><span class="sc-iemWCZ fhDkLh"></span><span>discount</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>discount fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_fee"><span class="sc-iemWCZ fhDkLh"></span><span>pg_fee</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>paygate fee fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="re_fee"><span class="sc-iemWCZ fhDkLh"></span><span>re_fee</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>reseller fee fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meNetAmount"><span class="sc-iemWCZ fhDkLh"></span><span>meNetAmount</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Merchant NetAmount fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meOtherTax1"><span class="sc-iemWCZ fhDkLh"></span><span>meOtherTax1</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Merchant OtherTax1 fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meOtherTax2"><span class="sc-iemWCZ fhDkLh"></span><span>meOtherTax2</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>merchant OtherTax2 fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meServiceTax"><span class="sc-iemWCZ fhDkLh"></span><span>meServiceTax</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>Merchant ServiceTax fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agNetAmount"><span class="sc-iemWCZ fhDkLh"></span><span>agNetAmount</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>aggregator NetAmount fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agOtherTax1"><span class="sc-iemWCZ fhDkLh"></span><span>agOtherTax1</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>aggregator OtherTax1 fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agOtherTax2"><span class="sc-iemWCZ fhDkLh"></span><span>agOtherTax2</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>aggregator OtherTax2 fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="agServiceTax"><span class="sc-iemWCZ fhDkLh"></span><span>agServiceTax</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>aggregator ServiceTax fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgNetAmount"><span class="sc-iemWCZ fhDkLh"></span><span>pgNetAmount</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>paygate NetAmount fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgOtherTax1"><span class="sc-iemWCZ fhDkLh"></span><span>pgOtherTax1</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>paygate OtherTax1 fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgOtherTax2"><span class="sc-iemWCZ fhDkLh"></span><span>pgOtherTax2</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>paygate OtherTax2 fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgServiceTax"><span class="sc-iemWCZ fhDkLh"></span><span>pgServiceTax</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>paygate ServiceTax fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="reNetAmount"><span class="sc-iemWCZ fhDkLh"></span><span>reNetAmount</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>reseller NetAmount fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="reOtherTax1"><span class="sc-iemWCZ fhDkLh"></span><span>reOtherTax1</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>reseller OtherTax1 fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="reOtherTax2"><span class="sc-iemWCZ fhDkLh"></span><span>reOtherTax2</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>reseller OtherTax2 fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="reServiceTax"><span class="sc-iemWCZ fhDkLh"></span><span>reServiceTax</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>reseller ServiceTax fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr class="last undefined">
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bank_response"><span class="sc-iemWCZ fhDkLh"></span><span>bank_response</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                    <p>bank response fetched.</p>
                                 </div>
                              </div>
                           </div>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         }
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>400 Bad request</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>404 Not found</span> </h5>
         </div>
      </div>
   </div>
</div>
<div class="col-md-4 extreme-rt-div">
   <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
      <div class="card">
         <div class="card-header" id="heading1">
            <h5 class="mb-0">
               <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab2}>
               <button> POST </button> /postResellerAPI_Endpoint {TabCheck2 ?
               <FaAngleUp />
               :
               <FaAngleDown />
               }
         </div>
         </h5>
      </div>
      {
      TabCheck2 &&
      <div>
         <br />
         <div class="card-body">
            <p class="mb-0">Production server (uses live data)</p>
            <div class="api-div-bor">
               <span>https://www.avantgardepayments.com</span>
               <span class="col-org">/agcore/postResellerAPI_Endpoint</span>
            </div>
            <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
            <div class="api-div-bor">
               <span>https://pguat.safexpay.com</span><span
                  class="col-org">/agcore/postResellerAPI_Endpoint</span>
            </div>
         </div>
      </div>
      }
   </div>
</div>
<RequestJSONflowone/>
<ResponseJSONflowone/>
</div>
</div>
</div>
</div>
)
}
export default ResellerAPI